import { render } from "./MvtInventory.vue?vue&type=template&id=3097330d"
import script from "./MvtInventory.vue?vue&type=script&lang=js"
export * from "./MvtInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__